import { HelpMessage } from 'utils/constants'
import { useNameColumn } from 'components/CIMSTable/common/hooks/useNameColumn'
import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { DSAction } from '../../../ActionsTableContext'
import { useOptionalDescriptionColumn } from 'components/CIMSTable/common/hooks/useDescriptionColumn'

export const useColumns = (): CIMSColumn<DSAction>[] => {
  return [
    useNameColumn({
      help: HelpMessage.DesignSubmittals.Actions.Name,
      width: 300,
      sort: { default: 'ascend' },
    }),
    useOptionalDescriptionColumn('Action'),
  ]
}
